// Copyright 2026. WebPros International GmbH. All rights reserved.

export const PLAN_CARD = 'plan-card';
export const CUSTOMIZE_PLAN = 'customize-plan';
